// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"n_h","video":"n_N","autoplay":"n_P"};